import React from 'react';
import { AccentIconName, RenderAccentIcon } from './Icons';
import { AccentIconSize } from './constants';

type AccentIconProps = {
  size?: keyof typeof AccentIconSize;
  name: AccentIconName;
  className?: string;
};

function AccentIcon({ size = 'small', name, className }: AccentIconProps) {
  const Icon = RenderAccentIcon(name);
  const dimension = AccentIconSize[size];
  return <Icon width={dimension} height={dimension} className={className} />;
}

export default AccentIcon;
